import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "link_highlight_bottom",
  "use": "link_highlight_bottom-usage",
  "viewBox": "0 0 73 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 73 37\" id=\"link_highlight_bottom\"><path fill=\"#8390FF\" d=\"m72 1.03.67.74A1 1 0 0 0 72 .03v1ZM33.416 34.98a1 1 0 0 0 .95 1.048l8.988.45a1 1 0 1 0 .1-1.997l-7.99-.4.4-7.99a1 1 0 1 0-1.997-.1l-.45 8.988ZM0 2.03H72v-2H0v2ZM71.33.287l-37.586 34 1.342 1.483 37.585-34L71.329.288Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol